import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  tableContainer: {
    boxShadow: "none",
    border: "1px solid #C6C6C6",
    borderRadius: "0px",
    width: "auto",
    display: "inline-block",
    overflowX: "auto",
  },
  table: {
    width: "auto",
    tableLayout: "fixed",
    borderCollapse: "collapse",
  },
  headerCell: {
    fontWeight: "bold",
    padding: "8px 10px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
    borderBottom: "1px solid #C6C6C6",
    fontSize: "14px",
    [theme.breakpoints.up(1680)]: {
      fontSize: "16px",
    },
  },
  tableCell: {
    padding: "8px 10px",
    borderBottom: "1px solid #C6C6C6",
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
    fontSize: "14px",
    [theme.breakpoints.up(1680)]: {
      fontSize: "16px",
    },
  },
}));

